import { RouteNames as AboutRouteNames } from './about'
import { RouteNames as CamerasRouteNames } from './cameras'
import { RouteNames as ClassesRouteNames } from './classes'
import { RouteNames as DatapoolsRouteNames } from './datapools'
import { RouteNames as InferenceMonitoringRouteNames } from './inferences'
import { RouteNames as MembersRouteNames } from './members'
import { RouteNames as PluginsRouteNames } from './plugins'
import { RouteNames as ProjectsRouteNames } from './projects'
import { RouteNames as ResourcesRouteNames } from './resources'
import { RouteNames as SettingsRouteNames } from './settings'


// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ModuleRouteNames =
  | AboutRouteNames
  | CamerasRouteNames
  | ClassesRouteNames
  | DatapoolsRouteNames
  | InferenceMonitoringRouteNames
  | MembersRouteNames
  | PluginsRouteNames
  | ProjectsRouteNames
  | ResourcesRouteNames
  | SettingsRouteNames

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ModuleRouteNames = {
  ...AboutRouteNames,
  ...CamerasRouteNames,
  ...ClassesRouteNames,
  ...DatapoolsRouteNames,
  ...InferenceMonitoringRouteNames,
  ...MembersRouteNames,
  ...PluginsRouteNames,
  ...ProjectsRouteNames,
  ...ResourcesRouteNames,
  ...SettingsRouteNames,
} as const
